"use client";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useIntl } from "@amazeelabs/react-intl";
import { Link, Locale, useLocation } from "@custom/schema";
import { CloseButton } from "@headlessui/react";
import clsx from "clsx";
import React from "react";
import { useTranslations } from "../../utils/translations";
export function LanguageSwitcher() {
    var _Object_entries_find;
    var translations = useTranslations();
    var _useLocation = _sliced_to_array(useLocation(), 1), location = _useLocation[0];
    var allLocales = Object.values(Locale);
    var currentLocale = (_Object_entries_find = Object.entries(translations).find(function(param) {
        var _param = _sliced_to_array(param, 2), path = _param[1];
        return path === location.pathname;
    })) === null || _Object_entries_find === void 0 ? void 0 : _Object_entries_find[0];
    var isCurrentLocale = function(locale) {
        return currentLocale === locale;
    };
    function getLanguageName(locale) {
        var languageNames = new Intl.DisplayNames(currentLocale !== null && currentLocale !== void 0 ? currentLocale : "en", {
            type: "language"
        });
        return languageNames.of(locale);
    }
    var intl = useIntl();
    return /*#__PURE__*/ React.createElement("nav", {
        "aria-labelledby": "lang-nav-label"
    }, /*#__PURE__*/ React.createElement("span", {
        id: "lang-nav-label",
        className: "sr-only"
    }, intl.formatMessage({
        defaultMessage: "Language navigation",
        id: "l2MD0d"
    })), /*#__PURE__*/ React.createElement("ul", {
        className: "flex flex-row gap-5 md:gap-7 items-center",
        "aria-labelledby": "lang-nav-label"
    }, allLocales.map(function(locale) {
        return /*#__PURE__*/ React.createElement("li", {
            key: locale
        }, translations[locale] && !isCurrentLocale(locale) ? /*#__PURE__*/ React.createElement(CloseButton, {
            as: Link,
            href: translations[locale],
            className: "text-base uppercase font-bold text-white hover:text-tcs-yellow transition-colors duration-200 leading-trim block",
            "aria-label": getLanguageName(locale)
        }, locale) : /*#__PURE__*/ React.createElement("span", {
            className: clsx(isCurrentLocale(locale) ? "text-theme-light" : "text-white", "text-base leading-snug font-bold uppercase leading-trim block"),
            "aria-label": getLanguageName(locale)
        }, locale));
    })));
}
